import $ from "jquery";
import 'bootstrap/js/dist/modal'

const TABLET_RESOLUTION = 1019;
const MODAL_BACKDROP_PATTERN = 'modal-backdrop-';

const classBackdrop = (element) => {
    return MODAL_BACKDROP_PATTERN + element.attr('data-modal');
};

const removeActiveBackdrop = (element) => {
    $('#modal-backdrop').removeClass(classBackdrop(element));
};

const addActiveBackdrop = (element) => {
    $('#modal-backdrop').addClass(classBackdrop(element));
};

export const scrollBarWidth = () => {
    return window.innerWidth - document.body.clientWidth;
};

export const bindEventsToModal = () => {
    const isDesktop = () => {
        return window.outerWidth > TABLET_RESOLUTION
    };

    $('.modal').on('show.bs.modal', function () {
        if (isDesktop()) {
            $("body").css("padding-right", scrollBarWidth());
            $(".header-wrapper").css("margin-right", scrollBarWidth());
        }
    });

    $('.modal').on('hidden.bs.modal', function () {
        if (isDesktop()) {
            $("body").css("padding-right", "0");
            $(".header-wrapper").css("margin-right", "0");
        }
    });

    $('[id$="-button"]').on("click", function () {
        addActiveBackdrop($(this));
    });

    $('.close').on("click", function () {
        removeActiveBackdrop($('.modal.show'));
    });

    $(document).mouseup(function (e) {
        const container = $(".modal-content");

        if (e.which === 1) {
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                removeActiveBackdrop($('.modal.show'));
            }
        }
    });
}
